(function () {
  if (window.__ssMenuEnhancementsInitialized) return;
  window.__ssMenuEnhancementsInitialized = true;

  var desktopQuery = window.matchMedia("(min-width: 990px)");
  var scrollRaf = 0;
  var lastScrollY = window.scrollY || document.documentElement.scrollTop || 0;

  function normalizePath(href) {
    try {
      var url = new URL(href, window.location.origin);
      return url.pathname.replace(/\/+$/, "") || "/";
    } catch (e) {
      return (href || "").replace(/\/+$/, "") || "/";
    }
  }

  function normalizeMenuKey(href) {
    var path = normalizePath(href || "");
    return path.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, "") || "/";
  }

  function lookupByNormalizedKey(map, href) {
    if (!map) return null;
    var direct = map[href];
    if (direct) return direct;
    var hrefKey = normalizeMenuKey(href);
    for (var key in map) {
      if (!Object.prototype.hasOwnProperty.call(map, key)) continue;
      if (normalizeMenuKey(key) === hrefKey) return map[key];
    }
    return null;
  }

  function getMenuImageFromLink(link) {
    if (!(link instanceof HTMLAnchorElement)) return "";

    var explicit = link.getAttribute("data-menu-preview-image");
    if (explicit) return explicit;

    var fromInnerImage = link.querySelector("img");
    if (fromInnerImage && fromInnerImage.getAttribute("src")) return fromInnerImage.getAttribute("src");

    var href = normalizePath(link.getAttribute("href") || "");
    var found = lookupByNormalizedKey(window.SS_MENU_IMAGES || {}, href);
    return found || "";
  }

  function getMenuMetaFromLink(link) {
    if (!(link instanceof HTMLAnchorElement)) return null;
    var href = normalizePath(link.getAttribute("href") || "");
    var data = lookupByNormalizedKey(window.SS_MENU_DATA || {}, href) || {};
    return {
      href: link.getAttribute("href") || "",
      image: getMenuImageFromLink(link),
      priceFrom: data.priceFrom || "",
      title: (link.textContent || "").trim()
    };
  }

  function extractPriceString(value) {
    if (typeof value === "string") return value.trim();
    if (!value || typeof value !== "object") return "";
    var keys = ["fromPrice", "priceFrom", "lowestPrice", "minPriceFormatted", "displayPrice", "price", "formatted"];
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (typeof value[key] === "string" && value[key].trim()) return value[key].trim();
    }
    return "";
  }

  function getEmbedPriceFromCandidate(candidate, href) {
    if (!candidate) return "";
    var methods = ["getPriceForUrl", "getPriceByUrl", "getPriceForPath", "getPriceByPath", "getPrice", "priceForUrl", "priceForPath"];
    for (var i = 0; i < methods.length; i++) {
      var method = methods[i];
      if (typeof candidate[method] !== "function") continue;
      try {
        var result = candidate[method](href) || candidate[method](window.location.origin + href) || candidate[method](href.replace(/^\//, ""));
        if (result && typeof result.then === "function") continue;
        var extracted = extractPriceString(result);
        if (extracted) return extracted;
      } catch (e) {}
    }
    return "";
  }

  function getPriceFromCustomEmbed(link) {
    if (!(link instanceof HTMLAnchorElement)) return "";
    var href = normalizePath(link.getAttribute("href") || "");
    var candidates = [
      window.CustomPriceEmbed,
      window.customPriceEmbed,
      window.CUSTOM_PRICE_EMBED,
      window.__CUSTOM_PRICE_EMBED__,
      window.customPrice,
      window.CustomPrice
    ];
    for (var i = 0; i < candidates.length; i++) {
      var price = getEmbedPriceFromCandidate(candidates[i], href);
      if (price) return price;
    }
    return "";
  }

  function formatPriceFromLabel(price) {
    if (!price) return "";
    var template = (window.SS_MENU_I18N && window.SS_MENU_I18N.priceFromTemplate) || "From __PRICE__";
    return template.replace("__PRICE__", price);
  }

  function getHeaderComponent() {
    return document.querySelector("#header-component");
  }

  function updateHeaderScrollState() {
    scrollRaf = 0;
    var header = getHeaderComponent();
    if (!(header instanceof HTMLElement)) return;

    var currentScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    var delta = currentScrollY - lastScrollY;
    header.classList.toggle("ss-header-scrolled", currentScrollY > 2);

    if (header.getAttribute("sticky") === "scroll-up") {
      if (currentScrollY <= 2) {
        header.dataset.stickyState = "inactive";
        header.dataset.scrollDirection = "none";
      } else if (delta < -2) {
        header.dataset.stickyState = "active";
        header.dataset.scrollDirection = "up";
      } else if (delta > 2) {
        header.dataset.stickyState = "idle";
        header.dataset.scrollDirection = "down";
      }
    }

    if (Math.abs(delta) > 1) lastScrollY = currentScrollY;
  }

  function scheduleHeaderScrollState() {
    if (scrollRaf) return;
    scrollRaf = requestAnimationFrame(updateHeaderScrollState);
  }

  function setMenuOpenState(isOpen) {
    var header = getHeaderComponent();
    if (header instanceof HTMLElement) {
      header.classList.toggle("ss-menu-open", isOpen);
      if (isOpen) {
        header.style.setProperty("--submenu-height", "0px");
        header.style.setProperty("--submenu-max-height", "0px");
        header.style.setProperty("--full-open-header-height", "0px");
      } else {
        header.style.removeProperty("--submenu-height");
        header.style.removeProperty("--submenu-max-height");
        header.style.removeProperty("--full-open-header-height");
      }
    }
    document.body.classList.toggle("ss-menu-open", isOpen);
  }

  function closeMenu(menu) {
    if (!(menu instanceof HTMLElement)) return;
    var openItems = menu.querySelectorAll(".menu-list__list-item.ss-is-open");
    for (var i = 0; i < openItems.length; i++) {
      openItems[i].classList.remove("ss-is-open");
    }
    var expanded = menu.querySelectorAll(".menu-list__link[aria-expanded='true']");
    for (var j = 0; j < expanded.length; j++) {
      expanded[j].setAttribute("aria-expanded", "false");
    }
    if (!document.querySelector(".header-menu .menu-list__list-item.ss-is-open")) {
      setMenuOpenState(false);
    }
  }

  function openMenuItem(item) {
    if (!(item instanceof HTMLElement) || !desktopQuery.matches) return;
    var menu = item.closest(".header-menu");
    if (!(menu instanceof HTMLElement)) return;

    var siblings = menu.querySelectorAll(".menu-list__list-item.ss-is-open");
    for (var i = 0; i < siblings.length; i++) {
      if (siblings[i] !== item) siblings[i].classList.remove("ss-is-open");
    }

    var links = menu.querySelectorAll(".menu-list__link[aria-expanded='true']");
    for (var j = 0; j < links.length; j++) {
      if (!item.contains(links[j])) links[j].setAttribute("aria-expanded", "false");
    }

    var trigger = item.querySelector(":scope > .menu-list__link[aria-controls]");
    if (!(trigger instanceof HTMLAnchorElement)) return;

    item.classList.add("ss-is-open");
    trigger.setAttribute("aria-expanded", "true");
    setMenuOpenState(true);
  }

  function isCompraTrigger(trigger) {
    if (!(trigger instanceof HTMLAnchorElement)) return false;
    var targets = window.SS_MENU_TARGETS && window.SS_MENU_TARGETS.compra ? window.SS_MENU_TARGETS.compra : null;
    var hrefKey = normalizeMenuKey(trigger.getAttribute("href") || "");
    if (targets) {
      var urls = Array.isArray(targets.urls) ? targets.urls : [];
      for (var i = 0; i < urls.length; i++) {
        if (normalizeMenuKey(urls[i] || "") === hrefKey) return true;
      }
      var titles = Array.isArray(targets.titles) ? targets.titles : [];
      var text = (trigger.textContent || "").trim().toLowerCase();
      for (var j = 0; j < titles.length; j++) {
        if ((titles[j] || "").toLowerCase() === text) return true;
      }
    }
    var title = (trigger.textContent || "").trim().toLowerCase();
    return /^(compra|shop|tienda|boutique|acheter)$/.test(title) || hrefKey === "/collections";
  }

  function getSubmenuInnerFromTrigger(trigger) {
    if (!(trigger instanceof HTMLAnchorElement)) return null;
    var submenuId = trigger.getAttribute("aria-controls");
    if (!submenuId) return null;
    var item = trigger.closest(".menu-list__list-item");
    if (!(item instanceof HTMLElement)) return null;
    var escapedId = window.CSS && typeof window.CSS.escape === "function"
      ? window.CSS.escape(submenuId)
      : submenuId.replace(/[^a-zA-Z0-9\-_:.]/g, "\\$&");
    var submenuInner = item.querySelector("#" + escapedId + ".menu-list__submenu-inner");
    return submenuInner instanceof HTMLElement ? submenuInner : null;
  }

  function ensurePreviewPanel(submenuInner) {
    var existing = submenuInner.querySelector(".ss-menu-preview__image");
    if (existing instanceof HTMLImageElement) {
      submenuInner.classList.add("ss-compra-preview-enabled");
      return existing;
    }

    submenuInner.classList.add("ss-compra-preview-enabled");

    var aside = document.createElement("aside");
    aside.className = "ss-menu-preview";
    aside.setAttribute("data-ss-preview", "");

    var anchor = document.createElement("a");
    anchor.className = "ss-menu-preview__link";
    anchor.href = "#";

    var img = document.createElement("img");
    img.className = "ss-menu-preview__image is-empty";
    img.alt = "";
    img.loading = "lazy";
    img.decoding = "async";

    var price = document.createElement("p");
    price.className = "ss-menu-preview__price";
    price.hidden = true;

    anchor.appendChild(img);
    aside.appendChild(anchor);
    aside.appendChild(price);
    submenuInner.appendChild(aside);
    return img;
  }

  function setPreviewFromLink(submenuInner, link) {
    if (!(submenuInner instanceof HTMLElement) || !(link instanceof HTMLAnchorElement)) return;
    var meta = getMenuMetaFromLink(link);
    if (!meta || !meta.image) return;

    var img = ensurePreviewPanel(submenuInner);
    if (img.getAttribute("src") !== meta.image) img.setAttribute("src", meta.image);
    img.classList.remove("is-empty");
    img.alt = meta.title;

    var previewLink = submenuInner.querySelector(".ss-menu-preview__link");
    if (previewLink instanceof HTMLAnchorElement && meta.href) {
      previewLink.href = meta.href;
      previewLink.setAttribute("aria-label", meta.title);
    }

    var priceNode = submenuInner.querySelector(".ss-menu-preview__price");
    if (priceNode instanceof HTMLElement) {
      var chosenPrice = meta.priceFrom || getPriceFromCustomEmbed(link) || "";
      priceNode.hidden = !chosenPrice;
      priceNode.textContent = chosenPrice ? formatPriceFromLabel(chosenPrice) : "";
    }
  }

  function initializeCompraPreview(trigger) {
    var submenuInner = getSubmenuInnerFromTrigger(trigger);
    if (!(submenuInner instanceof HTMLElement) || !isCompraTrigger(trigger)) return;
    submenuInner.classList.add("ss-compra-preview-enabled");
    var links = submenuInner.querySelectorAll(".mega-menu__link");
    for (var i = 0; i < links.length; i++) {
      if (links[i] instanceof HTMLAnchorElement && getMenuImageFromLink(links[i])) {
        setPreviewFromLink(submenuInner, links[i]);
        return;
      }
    }
    ensurePreviewPanel(submenuInner);
  }

  function ensureMobileDrawerThumbnails(scope) {
    var root = scope && typeof scope.querySelectorAll === "function" ? scope : document;
    var links = root.querySelectorAll(
      ".menu-drawer .menu-drawer__menu--childlist .menu-drawer__menu-item--child[href], .menu-drawer .menu-drawer__menu--childlist .menu-drawer__menu-item--parent[href]"
    );
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (!(link instanceof HTMLAnchorElement) || link.querySelector(".ss-mobile-menu-thumb")) continue;
      var image = getMenuImageFromLink(link);
      if (!image) continue;

      var img = document.createElement("img");
      img.className = "ss-mobile-menu-thumb";
      img.src = image;
      img.alt = "";
      img.loading = "lazy";
      img.decoding = "async";

      link.classList.add("ss-mobile-has-thumb");
      var textNode = link.querySelector(".menu-drawer__menu-item-text");
      if (textNode && textNode.nextSibling) {
        link.insertBefore(img, textNode.nextSibling);
      } else {
        link.appendChild(img);
      }
    }
  }

  function scheduleMobileDrawerThumbnails(scope) {
    requestAnimationFrame(function () {
      ensureMobileDrawerThumbnails(scope || document);
    });
  }

  function initMenuEnhancements(scope) {
    var root = scope && typeof scope.querySelectorAll === "function" ? scope : document;
    var menus = root.querySelectorAll(".header-menu");
    for (var i = 0; i < menus.length; i++) {
      menus[i].classList.add("ss-menu-dropdown-mode");
    }

    var triggers = root.querySelectorAll(".header-menu .menu-list__link[aria-controls]");
    for (var j = 0; j < triggers.length; j++) {
      if (triggers[j] instanceof HTMLAnchorElement) initializeCompraPreview(triggers[j]);
    }
    scheduleMobileDrawerThumbnails(root);
    updateHeaderScrollState();
  }

  document.addEventListener("pointerover", function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var item = target.closest(".header-menu .menu-list__list-item");
    if (item instanceof HTMLElement) openMenuItem(item);

    var previewLink = target.closest(".header-menu .menu-list__submenu-inner.ss-compra-preview-enabled .mega-menu__link");
    if (previewLink instanceof HTMLAnchorElement) {
      var submenuInner = previewLink.closest(".menu-list__submenu-inner.ss-compra-preview-enabled");
      if (submenuInner instanceof HTMLElement) setPreviewFromLink(submenuInner, previewLink);
    }
  });

  document.addEventListener("focusin", function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var item = target.closest(".header-menu .menu-list__list-item");
    if (item instanceof HTMLElement) openMenuItem(item);

    var previewLink = target.closest(".header-menu .menu-list__submenu-inner.ss-compra-preview-enabled .mega-menu__link");
    if (previewLink instanceof HTMLAnchorElement) {
      var submenuInner = previewLink.closest(".menu-list__submenu-inner.ss-compra-preview-enabled");
      if (submenuInner instanceof HTMLElement) setPreviewFromLink(submenuInner, previewLink);
    }
  });

  document.addEventListener("focusout", function (event) {
    var menu = event.target instanceof Element ? event.target.closest(".header-menu") : null;
    if (!(menu instanceof HTMLElement)) return;
    requestAnimationFrame(function () {
      if (!menu.contains(document.activeElement)) closeMenu(menu);
    });
  });

  document.addEventListener("pointerout", function (event) {
    var menu = event.target instanceof Element ? event.target.closest(".header-menu") : null;
    if (!(menu instanceof HTMLElement)) return;
    var next = event.relatedTarget;
    if (next instanceof Node && menu.contains(next)) return;
    closeMenu(menu);
  });

  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    if (!target.closest(".header-menu")) {
      var menus = document.querySelectorAll(".header-menu");
      for (var i = 0; i < menus.length; i++) closeMenu(menus[i]);
    }

    if (target.closest(".header__icon--summary, .menu-drawer__menu-item, .menu-drawer__back-button")) {
      scheduleMobileDrawerThumbnails(document);
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    var menus = document.querySelectorAll(".header-menu");
    for (var i = 0; i < menus.length; i++) closeMenu(menus[i]);
  });

  window.addEventListener("scroll", scheduleHeaderScrollState, { passive: true });
  window.addEventListener("resize", function () {
    if (!desktopQuery.matches) {
      var menus = document.querySelectorAll(".header-menu");
      for (var i = 0; i < menus.length; i++) closeMenu(menus[i]);
    }
    updateHeaderScrollState();
  });

  document.addEventListener("DOMContentLoaded", function () {
    initMenuEnhancements(document);
  });
  document.addEventListener("shopify:section:load", function (event) {
    initMenuEnhancements(event.target);
  });

  initMenuEnhancements(document);
})();
